<script lang="ts">
	import { AdaptiveTextInput } from "../TextInput";
	export let inputMode = false;
	export let inputId = "";
	export let name = "";
	export let value = "";
	export let placeholder = "";
	export let error = false;
	export let errorMessage = "";
	export let numeric = false;
	export let defaultPlaceholdValue = "";
	export let spaceBetween = false;

</script>

<div class="container" class:spaceBetween>
	<div class="name">{name}</div>
	{#if inputMode}
		{#if $$slots.input}
			<div class="input" class:error>
				<slot name="input" />
			</div>
		{:else}
			<div class="input-box input" class:error>
				<AdaptiveTextInput
					on:input
					on:keydown
					id={inputId}
					tel={numeric}
					error={error}
					bind:value
					backgroundColor={'#f0f0f4'}
					placeholder={placeholder}
					on:input />
			</div>
		{/if}
		{#if errorMessage}
			<span class:error class="error-message"> {errorMessage} </span>
		{/if}
	{:else}
		<p class="value">
			{#if $$slots.value}
				<slot name="value" />
			{:else}{value ? value : defaultPlaceholdValue}{/if}
		</p>
	{/if}
</div>

<style lang="scss">
	@import "../variables.scss";

	.container {
		width: 100%;
		display: flex;
		flex-direction: column;
		gap: 10px;

		.name {
			color: #6d6f76;
			font-size: 0.875rem;
			word-break: break-all;
		}

		.value {
			font-weight: 500;
			margin: 0;
			font-size: 1rem;
			color: #46474b;
			word-break: break-all;
		}
		p {
			margin: 0;
		}

		.input {
			color: #46474b;
		}
		.error {
			color: var(--error-color-1);
		}

		.input-box {
			height: 31px;
			font-weight: 200;
		}

		.error-message {
			font-size: 0.75rem;
		}

		&.spaceBetween {
			flex-direction: row;
			align-items: center;
			justify-content: space-between;
		}
	}

	@include DesktopSize {
		.container {
			.name {
				font-size: 1rem;
			}

			.value {
				font-weight: 500;
				word-break: break-all;
				font-size: 1.25rem;
			}

			.input-box {
				font-size: 1.25rem;
				height: 40px;
			}
			.error-message {
				font-size: 0.875rem;
			}
		}
	}

</style>
